/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import { put, takeEvery, select, call } from 'redux-saga/effects';
import { GET_CUSTOM_ROLES_LIMIT_BY_APP } from 'src/types/appconfig-action.type';
import { getCustomRolesLimitByAppSuccess, getCustomRolesLimitByAppError } from '../actions/appconfig.action';
import { ApimConfig } from 'src/utils/config';
import { parseResponse, requestApi } from 'src/providers/http-api.provider';
import { getPrettierMessage } from 'src/utils/global';
import { Messages } from 'src/constants/message.constant';

function* onGetCustomRolesLimit(action:any):any {
  let errorMessage = '';
  try {
    const platformToken = yield select(state => state.config?.platformToken);
    let data = action.payload;
    if (platformToken && data && data?.serviceId) {

       const endpoint = `${ApimConfig}/api/v1/services/${data.serviceId}/role-limit`;
      let response = yield call(requestApi, {
        endpoint,
        method: 'GET',
        headers: {
          Authorization: platformToken,
        },
        useParseResponse: false,
      });
      if (response?.ok) {
        let configLimit = yield call(parseResponse, response);
        let payloadData = {
          serviceId: data.serviceId,
          limit: configLimit?.roleLimit || 0,
        }
        yield put(getCustomRolesLimitByAppSuccess(payloadData));
      } else {
        const apiError = yield call(parseResponse, response);
        let apiErrorMessage = getPrettierMessage(apiError?.Message);
        if (apiErrorMessage) {
          errorMessage =`${apiErrorMessage} ${Messages.ERROR_GENERIC}`;
        }
        throw new Error(errorMessage);
      }
    } else {
      throw new Error ("accessToken empty");
    }
  } catch(err) {
    console.log("Fail onGetCustomRolesLimit: ", err);
    yield put(getCustomRolesLimitByAppError());
  }
}

export function* watchOnGetCustomRolesLimit() {
  yield takeEvery(GET_CUSTOM_ROLES_LIMIT_BY_APP, onGetCustomRolesLimit);
}